<template>
<header class="header-area bg-white">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-2">
                <div class="logo-box">
                    <Logo />
                </div>
            </div>
            <div class="col-lg-10">
                <div class="menu-wrapper border-left border-left-gray pl-4 justify-content-end" :class="isShowMenu ? 'active-menu' : ''">
                    <span class="show-menu" @click="isShowMenu=!isShowMenu">
                        <span class="transition-3s"></span>
                        <span class="transition-3s"></span>
                        <span class="transition-3s"></span>
                    </span>
                    
                    <NavBar @isMenuClose="isMenuClosed" />
                    
                    <SearchForm />
                    
                    <UserAction />
                    
                </div>
            </div>
        </div>
    </div>
</header>

</template>


<script>
import Logo from '@/components/common/Logo.vue';
import NavBar from '@/components/common/NavBar.vue';
import UserAction from '@/components/common/UserAction.vue';
import SearchForm from '@/components/common/SearchForm.vue';

export default {
    components: {
        Logo,
        NavBar,
        UserAction,
        SearchForm
    },
    data() {
        return {
            isShowMenu: false
        }
    },
    methods: {
        isMenuClosed(e) {
            this.isShowMenu = e;
        }
    }
}
</script>

<style scoped>

</style>

